import dayjs from 'dayjs';

export const isRenewAvailable = (contractEndDate: Date): boolean => {
  if (!contractEndDate) return false;

  const now = dayjs();
  const endDate = dayjs(contractEndDate);
  const startWindow = endDate.subtract(1, 'months');

  return now.isAfter(startWindow);
};
